import ChatSidebar from "../../components/chat/ChatSidebar";
import ChatHomepageCard from "../../components/chat/ChatHomepageCard";

const ChatHomepage = () => {
  return (
    <>
      <ChatSidebar />
      <ChatHomepageCard />
    </>
  );
};

export default ChatHomepage;
